import { useState, useEffect } from 'react';

const TRADE_ACTIVITY_TAB_LOCAL_STORAGE_KEY = 'tradeActivityPreferredTab';

// Simple event emitter for intra-tab sync
const listeners = new Set<(value: string) => void>();

function notifyListeners(newValue: string) {
  listeners.forEach((listener) => listener(newValue));
}

export function useTradeActiveTab(initialTab: string) {
  const getInitialValue = () => window.localStorage.getItem(TRADE_ACTIVITY_TAB_LOCAL_STORAGE_KEY) || initialTab;

  const [selectedTab, setSelectedTab] = useState<string>(getInitialValue);

  // Listen for storage events (cross-tab)
  useEffect(() => {
    const onStorage = (e: StorageEvent) => {
      if (e.key === TRADE_ACTIVITY_TAB_LOCAL_STORAGE_KEY && e.newValue) {
        setSelectedTab(e.newValue);
      }
    };

    window.addEventListener('storage', onStorage);
    return () => window.removeEventListener('storage', onStorage);
  }, []);

  // Listen for local changes (same tab, different components)
  useEffect(() => {
    const listener = (newValue: string) => {
      setSelectedTab(newValue);
    };
    listeners.add(listener);
    return () => {
      listeners.delete(listener);
    };
  }, []);

  const updateTab = (newTab: string) => {
    window.localStorage.setItem(TRADE_ACTIVITY_TAB_LOCAL_STORAGE_KEY, newTab);
    notifyListeners(newTab);
    setSelectedTab(newTab);
  };

  return { selectedTab, setSelectedTab: updateTab };
}
